<template>
  <div class="login-container">
    <Header class="login-header">
      <div class="logo" />
    </Header>
    <div class="login-content">
      <div class="bgc top"></div>
      <div class="bgc right"></div>
      <div class="bgc left"></div>
      <div class="bgc bottom"></div>
      <div class="login-form">
        <h2 class="login-title">账号登录</h2>
        <Form id="login_from" :form="form" class="form" @submit="handleSubmit">
          <FormItem class="item_icon" label="用户名" style="margin-top: 24px">
            <Input v-decorator="['userName']" placeholder="请输入用户名" />
          </FormItem>
          <FormItem class="item_icon pwd" label="密码">
            <Password
              type="password"
              class="login-verification-input"
              v-decorator="['password']"
              placeholder="请输入密码"
            />
          </FormItem>
          <FormItem
            class="item_icon code"
            label="验证码"
            :has-feedback="codeValidFlag"
            :validate-status="codeIconType"
          >
            <Row :gutter="8">
              <Col :span="16">
                <Input
                  v-decorator="['code']"
                  id="success"
                  placeholder="请输入验证码"
                />
              </Col>
              <Col :span="8">
                <a title="点击刷新" @click="getVeriftCode"
                  ><img :src="verifyImg" width="100" height="32"
                /></a>
              </Col>
            </Row>
          </FormItem>
          <div class="tips" v-show="!ErrorTipFlag"></div>
          <div class="tips" v-show="ErrorTipFlag" >
            <span><img src="@/assets/img/message.svg" alt="" /></span>
            <span>{{ tipsText }}</span>
          </div>
          <FormItem>
            <Button class="login-button" html-type="submit" type="primary">
              登录
            </Button>
          </FormItem>
        </Form>
      </div>
    </div>

    <Footer class="login-footer">
      {{copyright}}
    </Footer>
  </div>
  
</template>

<script>
import './index.less'
import { Layout, Form, Button, Input, Row, Col } from 'ant-design-vue'
const { Header, Footer } = Layout
const { Item: FormItem } = Form
const { Password } = Input
import { encodePwd } from '@/util/utils.js'
import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapMutations } = createNamespacedHelpers('user')
export default {
  data() {
    return {
      codeValidFlag: false, // 默认不展示图标
      ErrorTipFlag: false,
      tipsText: '',
      verifyImg: '',
      codeIconType: '',
      isDisable: 0,
      copyright:""
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'normal_login' })
  },
  created() {
    // 获取验证码
    this.getVeriftCode()
    this.getCopyright()
  },
  methods: {
    ...mapActions(['getCode', 'goToLogin', 'getLogin','getFooterCopyright']),
    ...mapMutations(['isLogin']),
    //获取验证码
    // getVeriftCode() {
    //   this.getCode().then((result) => {
    //     let src = window.URL.createObjectURL(result)
    //     this.verifyImg = src
    //   })
    // },
    getVeriftCode () {
      // this.verCode = ''
      this.verifyImg = '/rest/code/getCode?' + new Date().valueOf()
    },
     async getCopyright(){
       let res = await this.getFooterCopyright();
      this.copyright=res
    },

    // 验证码错误时，点击x，清空验证码

     
     
    

    // 点击刷新验证码
    // refreshCode() {
    //   this.getVeriftCode()
    // },

    // 提交
    handleSubmit(e) {
      e.preventDefault()
      this.isDisable++
      setTimeout(() => {
        this.isDisable = 0 //点击一次时隔两秒后才能再次点击
      }, 2000)
      this.form.validateFields((err, values) => {
        if (!err) {
          this.codeValidFlag = true
          let accountName = values.userName || ''
          let password = encodePwd(values.password || '')
          let captcha = values.code || ''
          if (
            accountName.trim() === '' ||
            password.trim() === '' ||
            captcha.trim() === ''
          ) {
            this.codeIconType = ''
            this.ErrorTipFlag = true
            this.tipsText = '账号或密码或验证码不能为空'
            this.getVeriftCode()
            return
          }
          // 调用登录接口
          if (this.isDisable != 1) return
          this.goToLogin({ accountName, password, captcha }).then((result) => {
            this.getVeriftCode()
            if (result?.id === 'CAPTCHA_ERROR') {
              this.codeIconType = 'error'
              this.ErrorTipFlag = true
              this.tipsText = result.msg
              this.form.setFieldsValue({code: ''})
              this.getVeriftCode()
            } else if (result.id == 'USER_BUSINESS') {
              this.codeIconType = ''
              this.ErrorTipFlag = true
              this.tipsText = result.msg
                this.getVeriftCode()
            } else if (result) {
              this.isLogin(true)
              this.codeIconType = 'success'
              this.$message.success('登录成功', 1)
              this.$router.push('/operations')
            }
          })
        }
      })
    },
  },
  components: {
    Header,
    Footer,
    Form,
    FormItem,
    Button,
    Input,
    Password,
    Row,
    Col,
  },
}
</script>
